import { FormControl, FormDescription, FormField, FormItem, FormMessage } from "@/components/ui/form";
import { useCallback } from "react";
import { CustomFieldProps } from '../custom-fields-container';
import { FormLabelWithIndicator } from "../form-label-with-indicator";

import {
  NumberField,
  NumberFieldInput
} from "@/components/ui/numberfield";
import { useFormContext } from "react-hook-form";
type CustomNumberFieldProps = CustomFieldProps & {
  decimalPlaces: number;
  min?: number;
  max?: number;
}

export function CustomNumberField({
  control,
  name,
  label,
  decimalPlaces,
  showDescription,
  description,
  showFormMessage,
  ...props
}: CustomNumberFieldProps) {

  const { trigger, setValue } = useFormContext();

  const handleKeyDown = useCallback((e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      e.stopPropagation(); // Stop event from bubbling up
    }

    // Allow: backspace, delete, tab, escape, enter, . and -
    if ([46, 8, 9, 27, 13, 110, 190, 189, 109].indexOf(e.keyCode) !== -1 ||
      // Allow: Ctrl+A, Command+A
      (e.keyCode === 65 && (e.ctrlKey === true || e.metaKey === true)) ||
      // Allow: home, end, left, right, down, up
      (e.keyCode >= 35 && e.keyCode <= 40)) {
      // let it happen, don't do anything
      return;
    }
    // Ensure that it is a number and stop the keypress
    if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
      e.preventDefault();
    }
  }, []);

  const handleOnChange = useCallback((value: number) => {
    console.debug('handleOnChange', name, value);
    setValue(name, value, { shouldDirty: true, shouldTouch: true, shouldValidate: true });
    trigger();
  }, [setValue, trigger, name]);

  return (
    <FormField
      control={control}
      name={name}
      render={({ field }) => (
        <FormItem>
          <FormLabelWithIndicator label={label} {...props} />
          <FormControl>
            <NumberField
              aria-label={label}
              className="w-full"
              {...field}
              onChange={(e) => handleOnChange(e)}
              formatOptions={{
                minimumFractionDigits: decimalPlaces,
                maximumFractionDigits: decimalPlaces,

              }}
              onBlur={() => {
                field.onBlur();
              }}
            >
              <NumberFieldInput
                className={"w-full rounded-md border border-input focus-visible:ring-0 focus-visible:ring-black focus-visible:border-ring"}
                onKeyDown={handleKeyDown}
              />
            </NumberField>
          </FormControl>
          {showDescription && <FormDescription>{description}</FormDescription>}
          {showFormMessage && <FormMessage />}
        </FormItem>
      )}
    />
  );
}
